<template>
  <!-- v-dialogよりプログレスバー が手前に出るようにz-index指定 -->
  <v-overlay :value="model" z-index="250">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: 'OverlayProgress',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {},
}
</script>
